import { render, staticRenderFns } from "./Turmacrud.vue?vue&type=template&id=ad2b5b98&scoped=true&"
import script from "./Turmacrud.vue?vue&type=script&lang=js&"
export * from "./Turmacrud.vue?vue&type=script&lang=js&"
import style0 from "./Turmacrud.vue?vue&type=style&index=0&id=ad2b5b98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2b5b98",
  null
  
)

export default component.exports